import React from 'react';

const DesktopCards = () => (
  <div className="upgrade-plans-container mobile-hidden">
    <div className="upgrade-row" style={{ flexFlow: 'unset' }}>
      <div className="seasonal-plan-container">
        <header className="plan-title plan-title__seasonal">Seasonal Plan</header>
        <span className="plan-subtitle-md">Pay Per Seasonal Box + Free Shipping!</span>
        <span className="plan-subtitle current-plan" style={{ display: 'block' }}>Current Plan</span>
        <hr />
        <ul className="plan-options">
          <li className="strike-through">
            <i className="far fa-times times-icon" />
            Early access to members only sales
          </li>
          <li className="strike-through">
            <i className="far fa-times times-icon" />
            More box customization offers
          </li>
          <li className="strike-through">
            <i className="far fa-times times-icon" />
            Earlier shipping
          </li>
          <li>
            <i className="far fa-check check-icon" />
            The Seasonal Box:
            {' '}
            <b>a $200+ value</b>
          </li>
          <li>
            <i className="far fa-check check-icon" />
            Customize your box
          </li>
          <li>
            <i className="far fa-check check-icon" />
            Members Only Sales
          </li>
        </ul>
      </div>
      <div className="annual-plan-container">
        <div style={{ position: 'relative' }}>
          <img
            className="best-value-desktop"
            /* eslint-disable-next-line max-len */
            src="https://s3.amazonaws.com/dev-abtesting-assets/upgrade plancomp/images/best-value-desktop.svg"
            alt="best value"
          />
          <header className="plan-title">Annual Plan</header>
        </div>
        <span className="plan-subtitle">$20 Instant Savings When you</span>
        <span
          className="plan-subtitle"
          style={{ display: 'block' }}
        >
          Prepay for 4 Boxes + Free Shipping
        </span>
        <hr />
        <ul className="plan-options">
          <li>
            <i className="far fa-check check-icon" />
            Early access to members only sales
          </li>
          <li>
            <i className="far fa-check check-icon" />
            More box customization offers
          </li>
          <li>
            <i className="far fa-check check-icon" />
            Earlier shipping
          </li>
          <li>
            <i className="far fa-check check-icon" />
            4 Seasonal Boxes:
            {' '}
            <b>an $800+ value</b>
          </li>
          <li>
            <i className="far fa-check check-icon" />
            Customize your box
          </li>
          <li>
            <i className="far fa-check check-icon" />
            Members Only Sales
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default DesktopCards;
